export default __webpack_public_path__ + "static/media/GothamLightItalic.d0f1bf8e.ttf";